import { client_v2 } from "utils/api";

const getWarehouseRacks = (query, aisle_id) =>
  new Promise((resolve, reject) =>
    client_v2
      .get(
        `/warehouse_racks?context=list&sort[order]=asc&sort[column]=position&q[warehouse_aisle_id_eq]=${aisle_id}&page=1&per_page=50&${
          query
            ? `&q[name_or_identifier_matches]=%25${query}%25`
            : ""
        }`
      )
      .then(({ data }) =>
        resolve(
          data?.map(({ id, name }) => ({
            label: name,
            value: id,
          }))
        )
      )
      .catch((err) => reject(err))
  );

export default getWarehouseRacks;
